enum CertificateEncryptDialogFields {
	KEY = "key",
	CERTIFICATE = "certificate",
	PRINTING = "printing",
	CAN_MODIFY = "can_modify",
	CAN_ASSEMBLE = "can_assemble",
	CAN_FILL_IN_FORM = "can_fill_in_form",
	CAN_MODIFY_ANNOTATIONS = "can_modify_annotations",
	CAN_EXTRACT_CONTENT = "can_extract_content",
	CAN_EXTRACT_FOR_ACCESSIBILITY = "can_extract_for_accessibility",
	ADD_RECEIPIENT = "add_receipient",
	REMOVE_RECEIPIENT = "remove_receipient",
	CONTENT_ENCRYPTION = "content_encryption"
}

export default CertificateEncryptDialogFields;